<template>
  <v-card>
    <v-card-title class="headline"
      >{{ vmd_linkSwitch ? "Link" : "Unlink" }} this product
    </v-card-title>
    <v-card-actions>
      <v-switch
        class="mx-4"
        v-model="vmd_linkSwitch"
        :label="vmd_linkSwitch ? 'Link' : 'Unlink'"
        @change="reset_linkClients"
      ></v-switch>
      <v-spacer></v-spacer>
      <v-combobox
        v-model="vmd_linkClients"
        chips
        clearable
        multiple
        solo
        :items="clients_list"
        :label="vmd_linkSwitch ? 'Link from client' : 'Unlink to client'"
        id="clients"
        item-text="text"
        item-value="value"
        class="custom_combobox mt-1"
        background-color="rgba(48, 127, 255, 0.1)"
      />
      <v-spacer></v-spacer>
      <v-btn
        text
        :ripple="false"
        class="ex-btn ex-primary-btn text--white mx-3"
        @click="$emit('exit_link')"
      >
        No
      </v-btn>
      <v-btn
        text
        :ripple="false"
        class="ex-btn ex-primary-btn text--white mx-3"
        @click="link_unlink_to_clients(vmd_linkSwitch)"
      >
        Yes {{ vmd_linkSwitch ? "Link" : "Unlink" }} It
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
export default {
  name: "N_MassiveLink",
  props: {
    product_ids: {
      type: Array,
      default: null,
      required: true,
    },
    // array with names of clients
    // store.selected_product.specs.product_clients.map(x => x.client_name)
    clients: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      vmd_linkClients: [], // link v-model
      vmd_linkSwitch: false, // link or unlink
    };
  },
  computed: {
    clients_list() {
      return this.$store.state.productionModule.clients_list;
    },
    availiable_clients_for_select() {
      return this.vmd_linkSwitch
        ? this.clients_list.filter((x) => !this.clients.includes(x.text))
        : this.clients_list.filter((x) => this.clients.includes(x.text));
    },
  },
  methods: {
    // create_linked_clients() {
    //   this.clients = [...this.$store.state.productionModule.conflict_temporary_data.clients];// 1st level clone array
    // },
    reset_linkClients() {
      this.vmd_linkClients = [];
    },
    link_unlink_to_clients(vmd_linkSwitch) {
      // keep in [] only the client ids (vmd_linkClients.value)
      const clients_ids = this.vmd_linkClients.map((x) => x.value);
      // const clients_ids = this.clients_list
      //                     .filter(x => this.vmd_linkClients.includes(x.value))
      //                     .map(x => x.value);
      console.log("selected array of clients ids", clients_ids);
      //create the payload for api
      const task = vmd_linkSwitch ? "linkToClients" : "unlinkFromClients";
      // const task = (vmd_linkSwitch) ? 'linkResolvedProduct' : 'unlinkResolvedProduct';
      const payload = {
        clients: clients_ids,
        product_ids: product_ids,
      };
      console.log("send - ", { task, payload });
      this.$store
        .dispatch("productionModule/general_api", { task, payload })
        .then((res) => {
          // this.notify("Link to client", "Client saved!");
          console.log("link-unlink results", res);
          this.$emit('success_linking');
        })
        .catch((err) => {
          // this.notify("Error", "Client dont linked!");
        });

      // reset values
      this.linkDialog = false;
      this.vmd_linkClients = [];
    },
    notify(title, message) {
      this.$notify({
        group: "save",
        title,
        text: message,
        duration: 500,
        speed: 600,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_MassiveLink.vue